export default {"src":"/_next/static/media/what3words.f288a84e.svg","height":23,"width":132,"blurWidth":0,"blurHeight":0};